import {
  Alert,
  Button,
  Col,
  Form,
  Modal,
  Row,
  message,
  Select,
  Typography,
} from "antd";
import React, { useEffect, useState, useRef } from "react";
import SimpleReactValidator from "simple-react-validator";
import { translate } from "../../locale";
import Company from "../../services/CompanyServices";

import CompanyServices from "../../services/CompanyServices";

const { Text } = Typography;

const ChangeRole = ({ data, onComplete, onCancel, enterpriseId }) => {
  const [loading, setLoading] = useState(false);
  const [active, setActive] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [values, setValues] = useState({
    subscriptions: "",
    role: "",
  });

  const [error, setError] = useState("");
  const [, forceUpdate] = useState();
  const roles = {
    "eira-super-admin": translate("Super Admin"),
    "eira-company-admin": translate("Admin"),
    "eira-company-coordinator": translate("Coordinador"),
    "eira-professional": translate("Profesional"),
    "eira-patient": translate("Paciente"),
  };
  const { Option } = Select;
  const [subscriptions, setSubscriptions] = useState([]);

  const simpleValidator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: forceUpdate },
      element: (message) => (
        <div className="text-red-600 pt-2 text-xs">{message}</div>
      ),
      messages: {
        required: "Campo requerido",
      },
    })
  );

  useEffect(() => {
    if (data !== null) {
      setActive(data !== false);
      if (data !== false && enterpriseId) {
        loadSubscriptions();
      }
    }
  }, [data, enterpriseId]);

  const loadSubscriptions = async () => {
    setLoading(true);
    try {
      const res = await CompanyServices.getSubscriptions(enterpriseId);
      if (
        res.status >= 200 &&
        res.status < 300 &&
        res.data.subscriptions.length > 0
      ) {
        setSubscriptions(res.data.subscriptions);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const disabled = () => !simpleValidator.current.allValid();

  const onFinish = () => {
    setShowConfirm(true);
  };

  const onConfirm = async () => {
    setLoading(true);
    setError("");
    if (!simpleValidator.current.allValid()) {
      simpleValidator.current.showMessages();
      forceUpdate();
      setError("Todos los datos son requeridos");
      return;
    }
    try {
      const _data = {
        username: data.username ? data.username : data.manager.username,
        rol: values.role,
        subscriptions: [values.subscriptions],
      };
      const res = await Company.updateStaff(_data);
      if (res) {
        if (res.status >= 200 && res.status < 300) {
          message.success(
            translate(
              "El {0} se realizó exitosamente.",
              translate("cambio de rol")
            )
          );
        } else {
          message.success(res.data.message, 6);
        }
        resetForm();
        setLoading(false);
        if (onComplete) {
          onComplete(data.user?.rol, values.role);
        }
      } else {
        setError(
          translate("La {0} no pudo ser guardada.", translate("píldora"))
        );
      }
    } catch (e) {
      console.log(e);
      setError(e.message);
      setLoading(false);
    }
  };

  const resetForm = () => {
    setValues({
      subscriptions: "",
      role: "",
    });
    simpleValidator.current.hideMessages();
    simpleValidator.current.visibleFields = [];
    forceUpdate();
  };

  const handleChange = (name, value) => {
    simpleValidator.current.purgeFields();

    setValues((v) => ({ ...v, [name]: value }));
  };

  const handleCancel = () => {
    resetForm();
    setActive(false);
    setShowConfirm(false);
    if (onCancel) {
      onCancel();
    }
  };

  return (
    <Modal
      open={active}
      title={translate("Cambiar rol")}
      onOk={null}
      onCancel={handleCancel}
      footer={false}
    >
      {error && (
        <Alert
          message={error}
          type="error"
          className="mb-6"
          closable
          onClose={() => setError("")}
        />
      )}
      {!showConfirm && (
        <Form
          initialValues={{ remember: true }}
          onFinish={onFinish}
          autoComplete="off"
          className="w-full"
        >
          <Form.Item>
            <Select
              name="role"
              onChange={(value) => handleChange("role", value)}
              value={values.role}
            >
              <Select.Option value="">
                {translate("Seleccione rol")}
              </Select.Option>
              {data.user?.rol !== "eira-company-admin" && (
                <Select.Option value="eira-company-admin">
                  {translate("Administrador")}
                </Select.Option>
              )}
              {data.user?.rol !== "eira-company-coordinator" && (
                <Select.Option value="eira-company-coordinator">
                  {translate("Coordinador")}
                </Select.Option>
              )}
              {data.user?.rol !== "eira-professional" && (
                <Select.Option value="eira-professional">
                  {translate("Profesional")}
                </Select.Option>
              )}
            </Select>
            {simpleValidator.current.message("role", values.role, "required")}
          </Form.Item>
          {data.user?.rol === "eira-company-admin" &&
            (values.role === "eira-company-coordinator" ||
              values.role === "eira-professional") && (
              <Form.Item>
                <Select
                  name="subscriptions"
                  onChange={(value) => handleChange("subscriptions", value)}
                  value={values.subscriptions}
                >
                  <Select.Option value="">Seleccione suscripción</Select.Option>
                  {subscriptions !== null &&
                    subscriptions.map((item, key) => (
                      <Select.Option span="6" key={key} value={item.id}>
                        {item.name}
                      </Select.Option>
                    ))}
                </Select>
                {simpleValidator.current.message(
                  "subscriptions",
                  values.subscriptions,
                  "required"
                )}
              </Form.Item>
            )}
          <Form.Item>
            <Row align="end" gutter={16}>
              <Col>
                <Button key="back" onClick={handleCancel}>
                  {translate("Cancelar")}
                </Button>
              </Col>
              <Col>
                <Button
                  disabled={disabled()}
                  htmlType="submit"
                  type="primary"
                  className="bg-custom_primary"
                  loading={loading}
                >
                  {translate("Guardar")}
                </Button>
              </Col>
            </Row>
          </Form.Item>
        </Form>
      )}
      {showConfirm && (
        <>
          <Row>
            <Col className="mb-6">
              <Text>
                {translate(
                  "¿Esta seguro que desea cambiar el rol de {0} de {1} a {2}?",
                  data.first_name
                    ? `"${data.first_name} ${data.last_name}"`
                    : data.manager?.full_name.length > 3
                    ? `"${data.manager?.full_name}"`
                    : `"${data.manager?.username}"`,
                  <Text className="font-bold">
                    {roles[data.user?.rol || data.manager?.rol]}
                  </Text>,
                  <Text className="font-bold">{roles[values.role]}</Text>
                )}
              </Text>
            </Col>
          </Row>
          <Row align="end" gutter={16}>
            <Col>
              <Button key="back" onClick={handleCancel}>
                {translate("Cancelar")}
              </Button>
            </Col>
            <Col>
              <Button
                type="primary"
                className="bg-custom_primary"
                loading={loading}
                onClick={onConfirm}
              >
                {translate("Confirmar")}
              </Button>
            </Col>
          </Row>
        </>
      )}
    </Modal>
  );
};

export default ChangeRole;
